'use client';

import sendNetworkReq from '@/utils/sendNetworkReq';
import { TextField, Button, Input } from '@mui/material';
import { useEffect, useState } from 'react';

export default function NewsletterForm() {
	const [email, setEmail] = useState();
	const [loading, setLoading] = useState(false);

	const submitEmail = async () => {
		setLoading(true);
		await sendNetworkReq({
			method: 'POST',
			url: 'users/newsletter',
			body: { email },
			auth: false,
			successMessage: "You've successfully subscribed to TinyTexts newsletter!",
		});
		setLoading(false);
	};

	return (
		<div>
			<div className='flex flex-col pr-10 pb-2'>
				<h2 className='flex !text-xl !font-semibold mb-1 justify-start text-left md:text-center'>
					Subscribe to our newsletter
				</h2>
				<div style={{ marginBottom: '10px' }}>
					<TextField
						fullWidth
						label='Email Address'
						type='email'
						name='EMAIL'
						required
						variant='outlined'
						InputLabelProps={{
							sx: {
								top: '0px',
								'&.Mui-focused, &.MuiInputLabel-shrink': {
									top: '10px',
								},
							},
						}}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</div>
				<div className='flex'>
					<Button
						type='submit'
						variant='contained'
						color='secondary'
						onClick={submitEmail}
						loading={loading}
					>
						Submit
					</Button>
				</div>
			</div>
		</div>
	);
}
